module.exports = __webpack_public_path__ + "img/icon-edit-light.b33740ac.svg";